import React from "react";
import t from "Utils/translation";
import { Icon, back } from "Icons/index";
import cx from "classnames";

const ButtonBack = ({ className, onClick, notHover, disabled, label }) => {
  return (
    <div
      className={cx(className, "flex items-center  h-6 gap-1 text-qb-blue", {
        ["hover:cursor-pointer hover:bg-blue-50 pr-1 rounded"]: !notHover && !disabled,
        ["cursor-not-allowed opacity-50"]: disabled,
      })}
      onClick={(e) => {
        !disabled && onClick !== undefined && onClick(e);
      }}
    >
      <Icon className="icon-accent" svg={back} width="1rem" height="1rem" />

      <div className="text-sm">{label || t("button.back")}</div>
    </div>
  );
};

export default ButtonBack;
